var regEmailCodeController = {
    elForm: $('#regEmailCodeForm'),
    regModalEmailCode: $('#regModalEmailCode'),
    regModalSetPass: $('#regModalSetPass'),
    code: '',
    submitting: false,
    init: function()
    {
        regEmailCodeController.elForm.find('.error-text').hide();
        regEmailCodeController.code = regEmailCodeController.elForm.find('.js-input-code').val();

        regEmailCodeController.elForm.on('keyup keypress', function(e) {
            var keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();

                return false;
            }
        });

        regEmailCodeController.elForm.find('.js-input-code').on('click change keyup blur input', function() {
            regEmailCodeController.code = $(this).val().trim();

            if(regEmailCodeController.code.length === 4) {
                regEmailCodeController.submitForm();
            } else {
                regEmailCodeController.clearForm();
            }

            return false;
        });
    },
    submitForm: function()
    {
        if (regEmailCodeController.submitting) {
            return false;
        }

        if (!regEmailCodeController.validateForm()) {
            regEmailCodeController.showError();

            return false;
        }

        regEmailCodeController.submitting = true;

        $.post(
            regEmailCodeController.elForm.attr('action'),
            regEmailCodeController.elForm.serialize(),

            function(data) {
                if (data.success) {
                    regEmailCodeController.regModalSetPass.modal('show');
                    regEmailCodeController.regModalSetPass.find('.js-input-username').val(
                        regEmailCodeController.elForm.find('.js-input-email').val()
                    );
                    regEmailCodeController.regModalSetPass.find('.js-input-reg-by-email').val(1);
                    regEmailCodeController.regModalSetPass.find('.js-input-reg-by-phone').val(0);
                    regEmailCodeController.regModalEmailCode.modal('hide');
                } else {
                    if(data.message) {
                        regEmailCodeController.regModalEmailCode.find('.error-text').text(data.message);
                        regEmailCodeController.showError();
                    }
                }
            }, 'json').always(function() {
                regEmailCodeController.submitting = false;
            });
    },
    validateForm: function()
    {
        regEmailCodeController.clearForm();

        return ($.isNumeric(regEmailCodeController.code) && regEmailCodeController.code.length === 4);
    },
    clearForm: function()
    {
        regEmailCodeController.elForm.find('.form-group').removeClass('has-error');
        regEmailCodeController.elForm.find('.error-text').hide();
    },
    showError: function()
    {
        regEmailCodeController.elForm.find('.form-group').addClass('has-error');
        regEmailCodeController.elForm.find('.error-text').show();
    }
};

$(function(){
    regEmailCodeController.init();
});